import { render, staticRenderFns } from "./CommonHeaderJa.vue?vue&type=template&id=d4470382&scoped=true&"
import script from "./CommonHeaderJa.vue?vue&type=script&lang=ts&"
export * from "./CommonHeaderJa.vue?vue&type=script&lang=ts&"
import style0 from "./CommonHeaderJa.vue?vue&type=style&index=0&id=d4470382&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4470382",
  null
  
)

export default component.exports